module.exports = __webpack_public_path__ + "img/button-home2.87004547.png";